export type ThemeQuestionDomain =
  | { source: 'question'; value: string }
  | { source: 'theme'; value: string }
  | { source: 'missing'; value: null };

export function resolveThemeQuestionDomain(
  questionDomain: string | null,
  themeSectorName: string,
): ThemeQuestionDomain {
  const questionValue = questionDomain?.trim();
  if (questionValue) return { source: 'question', value: questionValue };

  const themeValue = themeSectorName.trim();
  if (themeValue) return { source: 'theme', value: themeValue };

  return { source: 'missing', value: null };
}
